<div class="map-div">
    <div style="width:100%;height:100%" id="{{map_dom_id}}"></div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/map/map.component.html